const TitleStripe2 = ({ children, className }) => {
  return (
    <h2 className="text-lg font-bold text-gray-800 mb-3 border-b border-gray-200 pb-2">
      {children}
    </h2>
  );
};

export default TitleStripe2;
